module.exports = __webpack_public_path__ + "e99b45c39bd80730f560af702531fee6.svg";